module.exports = __webpack_public_path__ + "img/normal_multiplier_1.13292e52.png";